module.exports = __webpack_public_path__ + "static/media/fly0072.13c2da62.webp";